import "../chunk-BBZEL7EG.js";
var WalletScheme = /* @__PURE__ */ ((WalletScheme2) => {
  WalletScheme2["DKLS"] = "DKLS";
  WalletScheme2["CGGMP"] = "CGGMP";
  WalletScheme2["ED25519"] = "ED25519";
  return WalletScheme2;
})(WalletScheme || {});
var WalletType = /* @__PURE__ */ ((WalletType2) => {
  WalletType2["EVM"] = "EVM";
  WalletType2["SOLANA"] = "SOLANA";
  WalletType2["COSMOS"] = "COSMOS";
  return WalletType2;
})(WalletType || {});
var Chain = /* @__PURE__ */ ((Chain2) => {
  Chain2["ETH"] = "ETH";
  Chain2["CELO"] = "CELO";
  Chain2["MATIC"] = "MATIC";
  return Chain2;
})(Chain || {});
var Network = /* @__PURE__ */ ((Network2) => {
  Network2["ETHEREUM"] = "ETHEREUM";
  Network2["SEPOLIA"] = "SEPOLIA";
  Network2["ARBITRUM"] = "ARBITRUM";
  Network2["BASE"] = "BASE";
  Network2["OPTIMISM"] = "OPTIMISM";
  Network2["POLYGON"] = "POLYGON";
  Network2["SOLANA"] = "SOLANA";
  Network2["COSMOS"] = "COSMOS";
  Network2["CELO"] = "CELO";
  Network2["NOBLE"] = "NOBLE";
  Network2["SOLANA_DEVNET"] = "SOLANA_DEVNET";
  return Network2;
})(Network || {});
const PREGEN_IDENTIFIER_TYPES = ["EMAIL", "PHONE", "CUSTOM_ID", "DISCORD", "TWITTER", "TELEGRAM"];
const NON_ED25519 = ["DKLS" /* DKLS */, "CGGMP" /* CGGMP */];
export {
  Chain,
  NON_ED25519,
  Network,
  PREGEN_IDENTIFIER_TYPES,
  WalletScheme,
  WalletType
};
